// function numberCounter() {       
//         var dataId = $('.number-counter').attr('data-section-id');  
//         $('.inview-' + dataId + '-initialized').bind('inview', function(event, visible) {
//             if (visible) {
//                 //$(this).stop().animate({ opacity: 1 });

//                 $('.number-counter-value').each(function() {
//                     var $this = $(this),
//                         max_value = $this.attr('data-value');
//                     $({
//                         counter_value: $this.text()
//                     }).animate({
//                         counter_value: max_value
//                     }, {
//                         step: function step() {
//                             $this.text(Math.floor(this.counter_value));
//                         },
//                         duration: 1500,
//                         easing: 'swing',
//                         complete: function complete() {
//                             $this.text(this.counter_value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")); //For placing comma(,) after particular digit
//                         }
//                     });
//                 });
//             } else {
//                 //  $(this).stop().animate({ opacity: 0 });
//             }
//         });
//     }
//     $(document).ready(function(){
//     numberCounter();  
//     });

function numberCounter() {
    $('.number-counter').each(function () {
        var $section = $(this);
        var dataId = $section.attr('data-section-id');

        $('.inview-' + dataId + '-initialized').on('inview', function (event, visible) {
            if (visible) {

                $section.find('.number-counter-value').each(function () {
                    var $this = $(this);
                    var max_value = parseInt($this.attr('data-value'), 10);

                    $({ counter_value: 0 }).animate(
                        { counter_value: max_value },
                        {
                            duration: 1500,
                            easing: 'swing',
                            step: function () {
                                $this.text(Math.floor(this.counter_value));
                            },
                            complete: function () {
                                $this.text(
                                    this.counter_value
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                );
                            }
                        }
                    );
                });

                // run only once per section
                $(this).off('inview');
            }
        });
    });
}

$(document).ready(function () {
    numberCounter();
});